module.exports = __webpack_public_path__ + "img/395.5fe4b8bd.svg";